import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/mission/page.tsx");
